import { schema } from 'normalizr';

export const classSchema = new schema.Entity('classes');
